export const contactFormEs = {
  id: "site-enquiry",
  version: "v1.0.0",
  config: {
    submitText: "Enviar mensaje",
  },
  pages: [
    {
      id: "personal-details",
      questions: [
        {
          id: "name",
          required: true,
          title: "Nombre y Apellido",
          default: "userInfo:name",
          label: "Nombre",
          placeholder: "",
          type: "text",
        },
        {
          id: "type",
          required: true,
          title: "Indique el servicio que necesita",
          label: "Indique el servicio que necesita",
          default: "general-enquiry",
          placeholder: "",
          type: "select",
          options: [
            { name: "Preguntas generales de consulta", value: "general-enquiry" },
            { name: "Agenda una consulta privada con una de las terapistas", value: "supervision-request" },
            { name: "Comentarios y sugerencias", value: "general-feedback" },
            { name: "Soporte técnico", value: "account-issue" },
            { name: "Asistencia con el sitio web", value: "website-issue" },
            { name: "Otros motivos", value: "other" },
          ],
        },
        {
          id: "email",
          required: true,
          title: "Correo electrónico principal",
          default: "userInfo:email",
          label: "Correo electrónico principal",
          placeholder: "",
          type: "text",
        },
        {
          id: "message",
          required: true,
          title: "Mensaje",
          label: "Mensaje",
          type: "textarea",
        },
      ],
    },
  ],
};
